var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8523 19.5645H4.99691C3.28307 19.5645 2.42615 18.7076 2.42615 16.9938V10.1384C2.42615 8.42458 3.28307 7.56766 4.99691 7.56766H9.28151V16.9938C9.28151 18.7076 10.1384 19.5645 11.8523 19.5645Z",
    stroke: "white",
    strokeWidth: 1.28538,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3758 4.13997C9.30725 4.39705 9.28155 4.67983 9.28155 4.99689V7.56765H4.99695V5.85381C4.99695 4.9112 5.76818 4.13997 6.71079 4.13997H9.3758Z",
    stroke: "white",
    strokeWidth: 1.28538,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7092 7.56766V11.8523",
    stroke: "white",
    strokeWidth: 1.28538,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1368 7.56766V11.8523",
    stroke: "white",
    strokeWidth: 1.28538,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.28 15.2799H13.5661C13.0948 15.2799 12.7092 15.6656 12.7092 16.1369V19.5645H16.1369V16.1369C16.1369 15.6656 15.7513 15.2799 15.28 15.2799Z",
    stroke: "white",
    strokeWidth: 1.28538,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85376 11.8522V15.2799",
    stroke: "white",
    strokeWidth: 1.28538,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28149 16.9938V4.99689C9.28149 3.28305 10.1384 2.42613 11.8523 2.42613H16.9938C18.7076 2.42613 19.5645 3.28305 19.5645 4.99689V16.9938C19.5645 18.7076 18.7076 19.5645 16.9938 19.5645H11.8523C10.1384 19.5645 9.28149 18.7076 9.28149 16.9938Z",
    stroke: "white",
    strokeWidth: 1.28538,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.2d5df65a777eb42faf95d8a8a1d6f200.svg";
export { ForwardRef as ReactComponent };